import '../node_modules/bootstrap/dist/css/bootstrap.css';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { createApp } from 'vue';
import axios from 'axios';

import App from './App.vue';
import router from './router/router';
import $bus from './utils/Events';

const app = createApp(App);

// Configurar a URL base do Axios para chamar a api
axios.defaults.baseURL = 'https://nossaalianca.com/';
//axios.defaults.baseURL = 'http://127.0.0.1:8000';

axios.defaults.withCredentials = true; // Permitir cookies

// Tornar o Axios disponível globalmente
app.config.globalProperties.$axios = axios;

app.use(router);
app.provide('$bus', $bus);
app.mount('#app');